// src/services/questions.service.js
import { http } from "./http";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Construye el payload para la API de preguntas.
 * Admite:
 *  - categoryId: string (preferido) o
 *  - category: { id, name?, parent? }
 *  - answers: array tal cual lo envíes
 */
function buildPayload({ id, categoryId, category, text, answerType, answers }) {
  const categoryObj =
    categoryId ? { id: categoryId } : category ? category : undefined;

  return {
    ...(id ? { id } : {}),
    ...(categoryObj ? { category: categoryObj } : {}),
    text,
    answerType,
    answers,
  };
}

/** List of questions */
export async function listQuestions() {
  const { data } = await http.get(`${API_URL}/api/questions`);
  return data;
}

/** Get a question */
export async function getQuestion(id) {
  const { data } = await http.get(`${API_URL}/api/questions/${id}`);
  return data;
}

/** Add a question */
export async function createQuestion(dto) {
  const payload = buildPayload(dto);
  const { data } = await http.post(`${API_URL}/api/questions`, payload);
  return data;
}

/** Update a question */
export async function updateQuestion(id, dto) {
  const payload = buildPayload({ id, ...dto });
  const { data } = await http.put(`${API_URL}/api/questions/${id}`, payload);
  return data;
}

/** Delete a question */
export async function deleteQuestion(id) {
  const { data } = await http.delete(`${API_URL}/api/questions/${id}`);
  return data;
}

/** List of questions by Category Id (category or subcategory) */
export async function listQuestionsByCategory(categoryId) {
  const { data } = await http.get(`${API_URL}/api/questions/by-category/${categoryId}`);
  return data;
}